import { Navigate, Route, Routes } from 'react-router';
import DashboardPage from '../pages/DashboardPage';
import NotFoundContainer from '../pages/NotFoundPage';
import MapPage from '../pages/MapPage';
import ZoneImportOutcomePage from '../pages/ZoneImportOutcomePage';
import ZoneManagementPage from '../pages/ZoneManagementPage';
import Layout from './templates/Layout';

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Navigate to="/map" replace />} />
        <Route path="export" element={<DashboardPage />} />
        <Route path="zones" element={<ZoneManagementPage />} />
        <Route path="zones/imports/:jobId/outcome" element={<ZoneImportOutcomePage />} />
        {/* Canonical map; zone/location/workspace live in query params, keeping MapShell mounted. */}
        <Route path="map" element={<MapPage />} />
        <Route path="*" element={<NotFoundContainer />} />
      </Route>
    </Routes>
  );
}
